import { __values, __spread, __read } from 'tslib';
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * Creates an array of elements split into groups the length of `size`. If `array` can't be split evenly, the final chunk will be the remaining elements.
 *
 * Contribution to minified bundle size, when it is the only function imported:
 * - Lodash: 2,176 bytes
 * - Micro-dash: 139 bytes
 * @template T
 * @param {?} array
 * @param {?=} size
 * @return {?}
 */

function chunk(array, size) {
  if (size === void 0) {
    size = 1;
  }

  size = Math.max(Math.trunc(size), 0);
  /** @type {?} */

  var chunks = [];

  for (var i = 0; i < array.length; i += Math.max(1, size)) {
    chunks.push(array.slice(i, i + size));
  }

  return chunks;
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * This method returns the first argument it receives.
 *
 * Contribution to minified bundle size, when it is the only function imported:
 * - Lodash: 46 bytes
 * - Micro-dash: 23 bytes
 * @template T
 * @param {?} value
 * @return {?}
 */


function identity(value) {
  return value;
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * Creates an array with all falsey values removed. The values `false`, `null`, `0`, `""`, `undefined`, and `NaN` are falsey.
 *
 * Contribution to minified bundle size, when it is the only function imported:
 * - Lodash: 97 bytes
 * - Micro-dash: 36 bytes
 * @template T
 * @param {?} array
 * @return {?}
 */


function compact(array) {
  return (
    /** @type {?} */
    array.filter(identity)
  );
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * Flattens `array` a single level deep.
 *
 * Contribution to minified bundle size, when it is the only function imported:
 * - Lodash: 1,178 bytes
 * - Micro-dash: 39 bytes
 * @template T
 * @param {?} array
 * @return {?}
 */


function flatten(array) {
  return (
    /** @type {?} */
    [].concat.apply(
    /** @type {?} */
    [], __spread(array))
  );
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * Gets the last element of array.
 *
 * Differences from lodash:
 * - no special consideration is given to string-keyed values set on the array
 *
 * Contribution to minified bundle size, when it is the only function imported:
 * - Lodash: 69 bytes
 * - Micro-dash: 24 bytes
 * @template T
 * @param {?} array
 * @return {?}
 */


function last(array) {
  return array[array.length - 1];
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * @template T
 * @param {?} array
 * @param {?} predicate
 * @return {?}
 */


function remove(array, predicate) {
  /** @type {?} */
  var removed = [];

  for (var i = array.length; --i >= 0;) {
    if (predicate(array[i], i)) {
      removed.unshift(array[i]);
      array.splice(i, 1);
    }
  }

  return removed;
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * Removes all given values from array using `SameValueZero` for equality comparisons.
 *
 * Contribution to minified bundle size, when it is the only function imported:
 * - Lodash: 3,017 bytes
 * - Micro-dash: 381 bytes
 * @template T
 * @param {?} array
 * @param {...?} values
 * @return {?}
 */


function pull(array) {
  var values = [];

  for (var _i = 1; _i < arguments.length; _i++) {
    values[_i - 1] = arguments[_i];
  }

  var e_1, _a;

  var _loop_1 = function _loop_1(value) {
    remove(array, function (item) {
      return Object.is(item, value);
    });
  };

  try {
    for (var values_1 = __values(values), values_1_1 = values_1.next(); !values_1_1.done; values_1_1 = values_1.next()) {
      var value = values_1_1.value;

      _loop_1(value);
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (values_1_1 && !values_1_1.done && (_a = values_1.return)) _a.call(values_1);
    } finally {
      if (e_1) throw e_1.error;
    }
  }

  return array;
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * Removes elements from array corresponding to indexes and returns an array of removed elements.
 *
 * *Note:* This method mutates `array`.
 *
 * Differences from lodash:
 * - behavior is undefined when attempting to pull attributes keyed with anything other than positive integers
 * - does not support deep paths
 *
 * Contribution to minified bundle size, when it is the only function imported:
 * - Lodash: 7,723 bytes
 * - Micro-dash: 405 bytes
 * @param {?} array
 * @param {...?} indexes
 * @return {?}
 */


function pullAt(array) {
  var indexes = [];

  for (var _i = 1; _i < arguments.length; _i++) {
    indexes[_i - 1] = arguments[_i];
  }

  var e_1, _a;
  /** @type {?} */


  var flattenedIndexes = flatten(indexes);
  /** @type {?} */

  var result = flattenedIndexes.map(function (i) {
    return array[i];
  });
  /** @type {?} */

  var lastI;

  try {
    for (var _b = __values(flattenedIndexes.sort(function (a, b) {
      return b - a;
    })), _c = _b.next(); !_c.done; _c = _b.next()) {
      var i = _c.value;

      if (i !== lastI) {
        array.splice(i, 1);
      }

      lastI = i;
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
    } finally {
      if (e_1) throw e_1.error;
    }
  }

  return result;
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * Creates a duplicate-free version of an array, using `SameValueZero` for equality comparisons, in which only the first occurrence of each element is kept. The order of result values is determined by the order they occur in the array.
 *
 * Contribution to minified bundle size, when it is the only function imported:
 * - Lodash: 4,751 bytes
 * - Micro-dash: 36 bytes
 * @template T
 * @param {?} array
 * @return {?}
 */


function uniq(array) {
  return Array.from(new Set(array));
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * Creates an array excluding all given values.
 *
 * Differences from lodash:
 * - Uses triple equals rather than `SameValueZero`.
 *
 * Contribution to minified bundle size, when it is the only function imported:
 * - Lodash: 5,665 bytes
 * - Micro-dash: 119 bytes
 * @template T
 * @param {?} array
 * @param {...?} values
 * @return {?}
 */


function without(array) {
  var values = [];

  for (var _i = 1; _i < arguments.length; _i++) {
    values[_i - 1] = arguments[_i];
  }

  return array.filter(function (item) {
    return values.indexOf(item) === -1;
  });
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * Creates a function that returns `value`.
 *
 * Contribution to minified bundle size, when it is the only function imported:
 * - Lodash: 57 bytes
 * - Micro-dash: 26 bytes
 * @template T
 * @param {?} value
 * @return {?}
 */


function constant(value) {
  return function () {
    return value;
  };
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * Creates a debounced function that delays invoking `func` until after `wait` milliseconds have elapsed since the last time the debounced function was invoked. The `func` is invoked with the last arguments provided to the debounced function.
 *
 * If `wait` is 0, `func` invocation is deferred until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * Differences from lodash:
 * - the debounced function does not come with `cancel` or `flush` methods
 * - does not accept options
 * - does not return the results of the last invocation
 * - does not make any guarantees about the value of `this` in `func` is executed
 *
 * Contribution to minified bundle size, when it is the only function imported:
 * - Lodash: 1,988 bytes
 * - Micro-dash: 170 bytes
 * @param {?} func
 * @param {?=} wait
 * @return {?}
 */


function debounce(func, wait) {
  if (wait === void 0) {
    wait = 0;
  }
  /** @type {?} */


  var timeoutId;
  return function () {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    clearTimeout(timeoutId);
    timeoutId = setTimeout.apply(void 0, __spread([func, wait], args));
  };
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * @param {...?} funcs
 * @return {?}
 */


function flow() {
  var funcs = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    funcs[_i] = arguments[_i];
  }

  if (funcs.length) {
    return funcs.reduce(function (result, func) {
      return function (input) {
        return func(result(input));
      };
    });
  } else {
    return identity;
  }
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * @param {...?} funcs
 * @return {?}
 */


function flowRight() {
  var funcs = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    funcs[_i] = arguments[_i];
  }

  if (funcs.length) {
    return funcs.reduce(function (result, func) {
      return function (input) {
        return result(func(input));
      };
    });
  } else {
    return identity;
  }
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * Casts `value` as an array if it's not one.
 *
 * Contribution to minified bundle size, when it is the only function imported:
 * - Lodash: 128 bytes
 * - Micro-dash: 44 bytes
 * @template T
 * @param {?} value
 * @return {?}
 */


function castArray(value) {
  return (
    /** @type {?} */
    Array.isArray(value) ? value : [value]
  );
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * Creates a shallow clone of `value`.
 *
 * Contribution to minified bundle size, when it is the only function imported:
 * - Lodash: 12,251 bytes
 * - Micro-dash: 90 bytes
 * @template T
 * @param {?} value
 * @return {?}
 */


function clone(value) {
  if (Array.isArray(value)) {
    return (
      /** @type {?} */
      value.slice()
    );
  } else if (value instanceof Object) {
    return Object.assign({}, value);
  } else {
    return value;
  }
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * Creates an array of the own enumerable property names of object.
 *
 * Differences from lodash:
 * - does not give any special consideration for arrays, arguments objects, strings, or prototype objects (e.g. many will have `'length'` in the returned array)
 *
 * Contribution to minified bundle size, when it is the only function imported:
 * @template T
 * @param {?} object
 * @return {?}
 */


function keys(object) {
  if (object) {
    return (
      /** @type {?} */
      Object.getOwnPropertyNames(object)
    );
  } else {
    return [];
  }
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * Iterates over own enumerable string keyed properties of an object and invokes `iteratee` for each property.
 *
 * Differences from lodash:
 * - does not treat sparse arrays as dense
 *
 * Contribution to minified bundle size, when it is the only function imported:
 * - Lodash: 3,466 bytes
 * - Micro-dash: 247 bytes
 * @template T
 * @param {?} object
 * @param {?} iteratee
 * @return {?}
 */


function forOwn(object, iteratee) {
  var e_1, _a;

  try {
    for (var _b = __values(keys(object)), _c = _b.next(); !_c.done; _c = _b.next()) {
      var key = _c.value;

      if (iteratee(object[
      /** @type {?} */
      key], key) === false) {
        break;
      }
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
    } finally {
      if (e_1) throw e_1.error;
    }
  }

  return object;
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * This method is like `clone` except that it recursively clones `value`.
 *
 * Contribution to minified bundle size, when it is the only function imported:
 * - Lodash: 12,251 bytes
 * - Micro-dash: 412 bytes
 * @template T
 * @param {?} value
 * @return {?}
 */


function cloneDeep(value) {
  if (value instanceof Object) {
    value = clone(value);
    forOwn(value, function (item, key) {
      value[
      /** @type {?} */
      key] = cloneDeep(item);
    });
  }

  return value;
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * Checks if `value` is classified as a boolean primitive.
 *
 * Contribution to minified bundle size, when it is the only function imported:
 * - Lodash: 674 bytes
 * - Micro-dash: 35 bytes
 * @param {?} value
 * @return {?}
 */


function isBoolean(value) {
  return value === true || value === false;
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * Checks if `value` is an empty object or collection.
 *
 * Objects are considered empty if they have no own enumerable string keyed properties.
 *
 * Arrays are considered empty if they have a `length` of `0`.
 *
 * Contribution to minified bundle size, when it is the only function imported:
 * - Lodash: 4,248 bytes
 * - Micro-dash: 101 bytes
 * @param {?} value
 * @return {?}
 */


function isEmpty(value) {
  if (!Array.isArray(value)) {
    value = keys(value);
  }

  return value.length === 0;
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * Performs a deep comparison between two values to determine if they are equivalent.
 *
 * Differences from lodash:
 * - cannot handle circular references
 * - does not give special treatment to arrays; their own properties are compared just like other objects. Note this means sparse arrays are not equal to their dense "equivalents".
 * - `isEqual(0, -0) === false`
 *
 * Contribution to minified bundle size, when it is the only function imported:
 * - Lodash: 10,809 bytes
 * - Micro-dash: 536 bytes
 * @param {?} value
 * @param {?} other
 * @return {?}
 */


function isEqual(value, other) {
  var e_1, _a, e_2, _b;

  if (Object.is(value, other)) {
    // covers e.g. NaN === NaN
    return true;
  }

  if (!(value instanceof Object && other instanceof Object)) {
    return false;
  }

  try {
    for (var _c = __values(keys(value)), _d = _c.next(); !_d.done; _d = _c.next()) {
      var key = _d.value;

      if (!other.hasOwnProperty(key)) {
        return false;
      }
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
    } finally {
      if (e_1) throw e_1.error;
    }
  }

  try {
    for (var _e = __values(keys(other)), _f = _e.next(); !_f.done; _f = _e.next()) {
      var key = _f.value;

      if (!isEqual(value[key], other[key])) {
        return false;
      }
    }
  } catch (e_2_1) {
    e_2 = {
      error: e_2_1
    };
  } finally {
    try {
      if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
    } finally {
      if (e_2) throw e_2.error;
    }
  }

  return true;
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * Contribution to minified bundle size, when it is the only function imported:
 * - Lodash: 801 bytes
 * - Micro-dash: 41 bytes
 * @param {?} value
 * @return {?}
 */


function isFunction(value) {
  return typeof value === "function";
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * @param {?} collection
 * @param {?} iteratee
 * @return {?}
 */


function forEach(collection, iteratee) {
  if (Array.isArray(collection)) {
    for (var i = 0, l = collection.length; i < l; ++i) {
      if (iteratee(collection[i], i) === false) {
        break;
      }
    }
  } else {
    forOwn(collection, iteratee);
  }

  return collection;
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * @param {?} collection
 * @param {?} predicate
 * @return {?}
 */


function every(collection, predicate) {
  /** @type {?} */
  var result = true;
  forEach(collection, function (value, keyOrIndex) {
    return result = !!predicate(value, keyOrIndex);
  });
  return result;
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * Performs a partial deep comparison between `object` and `source` to determine if `object` contains equivalent property values.
 *
 * *Note:* This method is equivalent to `matches` when source is partially applied.
 *
 * Partial comparisons will match empty array and empty object source values against any array or object value, respectively.
 *
 * Differences from lodash:
 * - does not match `0` to `-0`
 *
 * Contribution to minified bundle size, when it is the only function imported:
 * - Lodash: 11,235 bytes
 * - Micro-dash: 1,048 bytes
 * @template T
 * @param {?} object
 * @param {?} source
 * @return {?}
 */


function isMatch(object, source) {
  return isEmpty(source) || isMatch0(object, source);
}
/**
 * @hidden
 * @template T
 * @param {?} object
 * @param {?} source
 * @return {?}
 */


function isMatch0(object, source) {
  var e_1, _a;

  if (Object.is(object, source)) {
    return true;
  }

  if (!(object instanceof Object && source instanceof Object)) {
    return false;
  }
  /** @type {?} */


  var isArray = Array.isArray(object);

  if (isArray !== Array.isArray(source)) {
    return false;
  }

  if (isArray) {
    /** @type {?} */
    var unmatched = object.slice();

    var _loop_1 = function _loop_1(innerSource) {
      /** @type {?} */
      var i = unmatched.findIndex(function (item) {
        return isMatch0(item, innerSource);
      });

      if (i < 0) {
        return {
          value: false
        };
      }

      unmatched.splice(i, 1);
    };

    try {
      for (var source_1 = __values(source), source_1_1 = source_1.next(); !source_1_1.done; source_1_1 = source_1.next()) {
        var innerSource = source_1_1.value;

        var state_1 = _loop_1(innerSource);

        if (typeof state_1 === "object") return state_1.value;
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (source_1_1 && !source_1_1.done && (_a = source_1.return)) _a.call(source_1);
      } finally {
        if (e_1) throw e_1.error;
      }
    }

    return true;
  } else {
    return every(source, function (value, key) {
      return object.hasOwnProperty(key) && isMatch0(object[key], value);
    });
  }
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * Checks if value is `null` or `undefined`.
 *
 * Contribution to minified bundle size, when it is the only function imported:
 * - Lodash: 74 bytes
 * - Micro-dash: 29 bytes
 * @param {?} value
 * @return {?}
 */


function isNil(value) {
  return value == null;
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * Checks if `value` is classified as a `Number` primitive.
 *
 * Contribution to minified bundle size, when it is the only function imported:
 * - Lodash: 676 bytes
 * - Micro-dash: 39 bytes
 * @param {?} value
 * @return {?}
 */


function isNumber(value) {
  return typeof value === "number";
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * Checks if `value` is classified as a `RegExp` object.
 *
 * Differences from lodash:
 * - returns `true` for subclasses of `RegExp`
 *
 * Contribution to minified bundle size, when it is the only function imported:
 * - Lodash: 1,003 bytes
 * - Micro-dash: 41 bytes
 * @param {?} value
 * @return {?}
 */


function isRegExp(value) {
  return value instanceof RegExp;
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * Checks if `value` is classified as a String primitive.
 *
 * Contribution to minified bundle size, when it is the only function imported:
 * - Lodash: 739 bytes
 * - Micro-dash: 39 bytes
 * @param {?} value
 * @return {?}
 */


function isString(value) {
  return typeof value === "string";
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * Checks if `value` is `undefined`.
 *
 * Contribution to minified bundle size, when it is the only function imported:
 * - Lodash: 77 bytes
 * - Micro-dash: 32 bytes
 * @param {?} value
 * @return {?}
 */


function isUndefined(value) {
  return value === undefined;
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * Converts `value` to a string. An empty string is returned for `null` and `undefined` values.
 *
 * Differences:
 * - `null` and `undefined` array references are blank
 *
 * Contribution to minified bundle size, when it is the only function imported:
 * - Lodash: 1,026 bytes
 * - Micro-dash: 35 bytes
 * @param {?} value
 * @return {?}
 */


function toString(value) {
  return [value].toString();
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * Creates a function that performs a partial deep comparison between a given `object` and `source`, returning `true` if the given object has equivalent property values, else `false`.
 *
 * Note: The created function is equivalent to `isMatch` with source partially applied.
 *
 * Partial comparisons will match empty array and empty object source values against any array or object value, respectively.
 *
 * Differences from lodash:
 * - does not match `0` to `-0`
 *
 * Contribution to minified bundle size, when it is the only function imported:
 * - Lodash: 15,993 bytes
 * - Micro-dash: 1,264 bytes
 * @param {?} source
 * @return {?}
 */


function matches(source) {
  source = cloneDeep(source);
  return function (value) {
    return isMatch(value, source);
  };
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * This method returns undefined.
 *
 * Contribution to minified bundle size, when it is the only function imported:
 * - Lodash: 43 bytes
 * - Micro-dash: 14 bytes
 * @return {?}
 */


function noop() {}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * Invokes the iteratee `n` times, returning an array of the results of each invocation.
 *
 * Differences from lodash:
 * - has undefined behavior when given a non natural number for `n`
 * - does not provide a default for `iteratee`
 *
 * Contribution to minified bundle size, when it is the only function imported:
 * - Lodash: 1,489 bytes
 * - Micro-dash: 49 bytes
 * @template T
 * @param {?} n
 * @param {?} iteratee
 * @return {?}
 */


function times(n, iteratee) {
  /** @type {?} */
  var result = [];

  for (var i = 0; i < n; ++i) {
    result[i] = iteratee(i);
  }

  return result;
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * @hidden
 * @type {?}
 */


var nextId = 1;
/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * Contribution to minified bundle size, when it is the only function imported:
 * - Lodash: 1,043 bytes
 * - Micro-dash: 54 bytes
 *
 * @param {?=} prefix
 * @return {?}
 */

function uniqueId(prefix) {
  if (prefix === void 0) {
    prefix = "";
  }

  return prefix + nextId++;
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * @template T
 * @param {...?} arrays
 * @return {?}
 */


function zip() {
  var arrays = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    arrays[_i] = arguments[_i];
  }
  /** @type {?} */


  var length = Math.max.apply(Math, __spread([0], arrays.map(function (a) {
    return a ? a.length : 0;
  })));
  return times(length, function (i) {
    return arrays.map(function (a) {
      return a ? a[i] : undefined;
    });
  });
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * @param {?} collection
 * @param {?} predicate
 * @return {?}
 */


function filter(collection, predicate) {
  /** @type {?} */
  var result = [];
  forEach(collection, function (item, indexOrKey) {
    if (predicate(item, indexOrKey)) {
      result.push(item);
    }
  });
  return result;
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * @param {?} collection
 * @param {?} predicate
 * @param {?=} fromIndex
 * @return {?}
 */


function find(collection, predicate, fromIndex) {
  if (fromIndex === void 0) {
    fromIndex = 0;
  }

  var e_1, _a;

  if (Array.isArray(collection)) {
    return collection.slice(fromIndex).find(function (item, index) {
      return predicate(item, index);
    });
  } else {
    try {
      for (var _b = __values(keys(collection).slice(fromIndex)), _c = _b.next(); !_c.done; _c = _b.next()) {
        var key = _c.value;
        /** @type {?} */

        var item = collection[key];

        if (predicate(item, key)) {
          return item;
        }
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
  }
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * This method is like `forOwn` except that it iterates over properties of `object` in the opposite order.
 *
 * Differences from lodash:
 * - does not treat sparse arrays as dense
 *
 * Contribution to minified bundle size, when it is the only function imported:
 * - Lodash: 3,473 bytes
 * - Micro-dash: 192 bytes
 * @template T
 * @param {?} object
 * @param {?} iteratee
 * @return {?}
 */


function forOwnRight(object, iteratee) {
  forEachRight(keys(object), function (key) {
    return iteratee(object[
    /** @type {?} */
    key], key);
  });
  return object;
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * @template T
 * @param {?} collection
 * @param {?} iteratee
 * @return {?}
 */


function forEachRight(collection, iteratee) {
  if (Array.isArray(collection)) {
    for (var i = collection.length; --i >= 0;) {
      if (iteratee(collection[i], i) === false) {
        break;
      }
    }
  } else {
    forOwnRight(collection, iteratee);
  }

  return collection;
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * @param {?} object
 * @param {?} path
 * @param {?=} defaultValue
 * @return {?}
 */


function get(object, path, defaultValue) {
  // const val = property(path)(object);
  // return isUndefined(val) ? defaultValue : val;

  /** @type {?} */
  var length = path.length;
  /** @type {?} */

  var index = 0;

  while (object != null && index < length) {
    object = object[path[index++]];
  }

  return !index || index < length || object === undefined ? defaultValue : object;
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * Creates an object with the same keys as `object` and values generated by running each own enumerable string keyed property of `object` thru `iteratee`.
 *
 * Contribution to minified bundle size, when it is the only function imported:
 * - Lodash: 14,120 bytes
 * - Micro-dash: 302 bytes
 * @template T, O
 * @param {?} object
 * @param {?} iteratee
 * @return {?}
 */


function mapValues(object, iteratee) {
  /** @type {?} */
  var obj = {};
  forOwn(object, function (value, key) {
    obj[
    /** @type {?} */
    key] = iteratee(value, key);
  });
  return obj;
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * @param {?} object
 * @param {...?} sources
 * @return {?}
 */


function merge(object) {
  var sources = [];

  for (var _i = 1; _i < arguments.length; _i++) {
    sources[_i - 1] = arguments[_i];
  }

  var e_1, _a;

  try {
    for (var sources_1 = __values(sources), sources_1_1 = sources_1.next(); !sources_1_1.done; sources_1_1 = sources_1.next()) {
      var source = sources_1_1.value;
      forEach(source, function (value, key) {
        /** @type {?} */
        var myValue = object[key];

        if (myValue instanceof Object) {
          value = merge(clone(myValue), value);
        }

        object[key] = value;
      });
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (sources_1_1 && !sources_1_1.done && (_a = sources_1.return)) _a.call(sources_1);
    } finally {
      if (e_1) throw e_1.error;
    }
  }

  return object;
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * The opposite of `pick`; this method creates an object composed of the own enumerable string properties of object that are not omitted.
 *
 * Differences from lodash:
 * - `paths` must be direct keys of `object` (they cannot refer to deeper properties)
 * - does not work with arrays
 *
 * Contribution to minified bundle size, when it is the only function imported:
 * - Lodash: 15,624 bytes
 * - Micro-dash: 329 bytes
 * @template T
 * @param {?} object
 * @param {...?} paths
 * @return {?}
 */


function omit(object) {
  var paths = [];

  for (var _i = 1; _i < arguments.length; _i++) {
    paths[_i - 1] = arguments[_i];
  }

  var e_1, _a;
  /** @type {?} */


  var obj = clone(object) || {};

  try {
    for (var paths_1 = __values(paths), paths_1_1 = paths_1.next(); !paths_1_1.done; paths_1_1 = paths_1.next()) {
      var path = paths_1_1.value;
      delete obj[path];
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (paths_1_1 && !paths_1_1.done && (_a = paths_1.return)) _a.call(paths_1);
    } finally {
      if (e_1) throw e_1.error;
    }
  }

  return obj;
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * @template T
 * @param {?} object
 * @param {?} predicate
 * @return {?}
 */


function pickBy(object, predicate) {
  /** @type {?} */
  var obj = {};
  forOwn(object, function (item, key) {
    if (predicate(item, key)) {
      obj[key] = item;
    }
  });
  return obj;
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * The opposite of `pickBy`; this method creates an object composed of the own enumerable string keyed properties of `object` that `predicate` doesn't return truthy for.
 *
 * Differences from lodash:
 * - does not treat sparse arrays as dense
 *
 * Contribution to minified bundle size, when it is the only function imported:
 * - Lodash: 15,380 bytes
 * - Micro-dash: 375 bytes
 * @template T
 * @param {?} object
 * @param {?} predicate
 * @return {?}
 */


function omitBy(object, predicate) {
  return pickBy(object, function (item, key) {
    return !predicate(item, key);
  });
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * Creates an object composed of the picked `object` properties.
 *
 * Differences from lodash:
 * - `paths` must be direct properties of `object` (they cannot references deep properties)
 *
 * Contribution to minified bundle size, when it is the only function imported:
 * - Lodash: 7,778 bytes
 * - Micro-dash: 278 bytes
 * @template T, K
 * @param {?} object
 * @param {...?} paths
 * @return {?}
 */


function pick(object) {
  var paths = [];

  for (var _i = 1; _i < arguments.length; _i++) {
    paths[_i - 1] = arguments[_i];
  }

  var e_1, _a;
  /** @type {?} */


  var result = {};

  if (object != null) {
    try {
      for (var paths_1 = __values(paths), paths_1_1 = paths_1.next(); !paths_1_1.done; paths_1_1 = paths_1.next()) {
        var path = paths_1_1.value;
        result[path] = object[path];
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (paths_1_1 && !paths_1_1.done && (_a = paths_1.return)) _a.call(paths_1);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
  }

  return result;
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * This method is like `set()` except that it accepts `updater` to produce the value to set.
 *
 * **Note:** This method mutates `object`.
 *
 * Differences from lodash:
 * - only accepts an array for `path`, not a dot-separated string
 * - does not handle `customizer` returning `undefined`
 *
 * Contribution to minified bundle size, when it is the only function imported:
 * - Lodash: 5,946 bytes
 * - Micro-dash: 164 bytes
 * @template T
 * @param {?} object
 * @param {?} path
 * @param {?} updater
 * @return {?}
 */


function update(object, path, updater) {
  if (object && path.length) {
    /** @type {?} */
    var current = object;
    /** @type {?} */

    var length_1 = path.length;

    for (var i = 0; i < length_1; ++i) {
      /** @type {?} */
      var key = path[i];
      /** @type {?} */

      var value = current[key];

      if (i < length_1 - 1) {
        if (!(value instanceof Object)) {
          value = Number.isInteger(
          /** @type {?} */
          path[i + 1]) ? [] : {};
        }
      } else {
        value = updater(value);
      }

      current = current[key] = value;
    }
  }

  return object;
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist, it's created. Arrays are created for missing index properties while objects are created for all other missing properties.
 *
 * **Note:** This method mutates `object`.
 *
 * Differences from lodash:
 * - only accepts an array for `path`, not a dot-separated string
 * - does not handle `customizer` returning `undefined`
 *
 * Contribution to minified bundle size, when it is the only function imported:
 * - Lodash: 5,716 bytes
 * - Micro-dash: 201 bytes
 * @template T
 * @param {?} object
 * @param {?} path
 * @param {?} value
 * @return {?}
 */


function set(object, path, value) {
  return update(object, path, constant(value));
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * Contribution to minified bundle size, when it is the only function imported:
 * - Lodash: 3,368 bytes
 * - Micro-dash: 82 bytes
 * @template T
 * @param {?} object
 * @return {?}
 */


function values(object) {
  return keys(object).map(function (key) {
    return object[
    /** @type {?} */
    key];
  });
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's checked for a substring of `value`, otherwise `SameValueZero` is used for equality comparisons. If `fromIndex` is negative, it's used as the offset from the end of `collection`.
 *
 * ```ts
 * includes([1, 2, 3], 1); // true
 * includes([1, 2, 3], 1, 2); // false
 * includes({ a: 1, b: 2 }, 1); // true
 * includes('abcd', 'bc'); // true
 * ```
 *
 * Contribution to minified bundle size, when it is the only function imported:
 * - Lodash: 4,514 bytes
 * - Micro-dash: 210 bytes
 * @template T
 * @param {?} collection
 * @param {?} value
 * @param {?=} fromIndex
 * @return {?}
 */


function includes(collection, value, fromIndex) {
  if (fromIndex === void 0) {
    fromIndex = 0;
  }

  return (
  /** @type {?} */
  isString(collection) || Array.isArray(collection) ? collection : values(collection)).includes(value, fromIndex);
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * @template T
 * @param {?} collection
 * @param {?} iteratee
 * @return {?}
 */


function keyBy(collection, iteratee) {
  /** @type {?} */
  var obj = {};
  forEach(collection, function (value) {
    obj[iteratee(value)] = value;
  });
  return obj;
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * @param {?} collection
 * @param {?} iteratee
 * @return {?}
 */


function map(collection, iteratee) {
  /** @type {?} */
  var mapped = [];
  forEach(collection, function (value, keyOrIndex) {
    mapped.push(iteratee(value, keyOrIndex));
  });
  return mapped;
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * @param {?} collection
 * @param {?} iteratee
 * @param {?=} accumulator
 * @return {?}
 */


function reduce(collection, iteratee, accumulator) {
  return doReduce(forEach, collection, iteratee, accumulator, arguments.length < 3);
}
/**
 * @param {?} collection
 * @param {?} iteratee
 * @param {?=} accumulator
 * @return {?}
 */


function reduceRight(collection, iteratee, accumulator) {
  return doReduce(forEachRight, collection, iteratee, accumulator, arguments.length < 3);
}
/**
 * @hidden
 * @param {?} iterationFn
 * @param {?} collection
 * @param {?} iteratee
 * @param {?} accumulator
 * @param {?} initAccum
 * @return {?}
 */


function doReduce(iterationFn, collection, iteratee, accumulator, initAccum) {
  iterationFn(collection, function (value, indexOrKey) {
    if (initAccum) {
      accumulator = value;
      initAccum = false;
    } else {
      accumulator = iteratee(accumulator, value, indexOrKey);
    }
  });
  return accumulator;
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * @param {?} collection
 * @param {?} iteratees
 * @return {?}
 */


function sortBy(collection, iteratees) {
  /** @type {?} */
  var fns = castArray(iteratees);
  /** @type {?} */

  var index = 0;
  /** @type {?} */

  var metas = map(collection, function (value) {
    var e_1, _a;
    /** @type {?} */


    var meta =
    /** @type {?} */
    [];
    meta.value = value;

    try {
      for (var fns_1 = __values(fns), fns_1_1 = fns_1.next(); !fns_1_1.done; fns_1_1 = fns_1.next()) {
        var fn = fns_1_1.value;
        /** @type {?} */

        var v = fn(value);
        meta.push(ordinal(v), v);
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (fns_1_1 && !fns_1_1.done && (_a = fns_1.return)) _a.call(fns_1);
      } finally {
        if (e_1) throw e_1.error;
      }
    }

    meta.push(index++);
    return meta;
  });
  metas.sort(function (m1, m2) {
    for (var i = 0; i < m1.length; ++i) {
      if (m1[i] < m2[i]) {
        return -1;
      } else if (m1[i] > m2[i]) {
        return 1;
      }
    }
  });
  return metas.map(function (e) {
    return e.value;
  });
}
/**
 * @param {?} value
 * @return {?}
 */


function ordinal(value) {
  if (Number.isNaN(value)) {
    return 3;
  }

  if (value === undefined) {
    return 2;
  }

  if (value === null) {
    return 1;
  }

  return 0;
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * @param {?} func
 * @param {...?} partials
 * @return {?}
 */


function partial(func) {
  var partials = [];

  for (var _i = 1; _i < arguments.length; _i++) {
    partials[_i - 1] = arguments[_i];
  }

  return func.bind.apply(func, __spread([undefined], partials));
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * @param {?} func
 * @param {?=} arity
 * @return {?}
 */


function curry(func, arity) {
  if (arity === void 0) {
    arity = func.length;
  }

  return function () {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    if (args.length < arity) {
      return curry(partial.apply(void 0, __spread([func], args)),
      /** @type {?} */
      arity - args.length);
    } else {
      return func.apply(this, args);
    }
  };
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is provided, it determines the cache key for storing the result based on the arguments provided to the memoized function. By default, the first argument provided to the memoized function is used as the map cache key. The `func` is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized function.
 *
 * Differences from lodash:
 * - does not coerce keys to a string; any object can be used as in an ES6 `Map`
 * - does not let you customize cache creation
 *
 * Contribution to minified bundle size, when it is the only function imported:
 * - Lodash: 3,920 bytes
 * - Micro-dash: 218 bytes
 *
 * @template T
 * @param {?} func
 * @param {?=} resolver The function to resolve the cache key.
 * @return {?}
 */


function memoize(func, resolver) {
  if (resolver === void 0) {
    resolver = identity;
  }
  /** @type {?} */


  var memoized = function memoized() {
    /** @type {?} */
    var cache = memoized.cache;
    /** @type {?} */

    var key = resolver.apply(this, arguments);

    if (cache.has(key)) {
      return cache.get(key);
    } else {
      /** @type {?} */
      var value = func.apply(this, arguments);
      cache.set(key, value);
      return value;
    }
  };

  memoized.cache = new Map();
  return memoized;
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * Creates a function that is restricted to invoking `func` once. Repeat calls to the function return the value of the first invocation. The `func` is invoked with the `this` binding and arguments of the created function.
 *
 * Contribution to minified bundle size, when it is the only function imported:
 * - Lodash: 1,421 bytes
 * - Micro-dash: 67 bytes
 * @template T
 * @param {?} func
 * @return {?}
 */


function once(func) {
  /** @type {?} */
  var result;
  /** @type {?} */

  var needsCall = true;
  return (
    /** @type {?} */

    /** @type {?} */
    function () {
      if (needsCall) {
        needsCall = false;
        result = func.apply(this, arguments); // allow func and any of its variables to be garbage collected

        /** @type {?} */
        func = null;
      }

      return result;
    }
  );
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * This method is like `min` except that it accepts `iteratee` which is invoked for each element in `array` to generate the criterion by which the value is ranked.
 *
 * Contribution to minified bundle size, when it is the only function imported:
 * - Lodash: 13,897 bytes
 * - Micro-dash: 421 bytes
 * @template T
 * @param {?} array
 * @param {?} iteratee
 * @return {?}
 */


function minBy(array, iteratee) {
  /** @type {?} */
  var min;
  /** @type {?} */

  var minCriterion;
  forEach(array, function (value) {
    /** @type {?} */
    var criterion = iteratee(value);

    if (min === undefined || criterion < minCriterion) {
      min = value;
      minCriterion = criterion;
    }
  });
  return (
    /** @type {?} */
    min
  );
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * @param {...?} args
 * @return {?}
 */


function random() {
  var args = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }

  var _a, _b, _c;
  /** @type {?} */


  var lower = 0;
  /** @type {?} */

  var upper = 1;

  if (isFinite(args[1])) {
    _a = __read(args, 2), lower = _a[0], upper = _a[1];
  } else if (isFinite(args[0])) {
    _b = __read(args, 1), upper = _b[0];
  }

  _c = __read([lower, upper].sort(), 2), lower = _c[0], upper = _c[1];
  /** @type {?} */

  var floating = last(args);

  if (!isBoolean(floating)) {
    floating = !Number.isInteger(lower) && !Number.isInteger(upper);
  }
  /** @type {?} */


  var range = upper - lower;

  if (!floating) {
    ++range;
  }
  /** @type {?} */


  var result = Math.random() * range + lower;

  if (!floating) {
    result = Math.floor(result);
  }

  return result;
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * Computes `number` rounded to `precision`.
 *
 * ```ts
 * round(4.006); // 4
 * round(4.006, 2); // 4.01
 * round(4060, -2); // 4100
 * ```
 *
 * Differences from lodash:
 * - may return `NaN` with large `precision` values
 *
 * Contribution to minified bundle size, when it is the only function imported:
 * - Lodash: 1,803 bytes
 * - Micro-dash: 92 bytes
 * @param {?} number
 * @param {?=} precision
 * @return {?}
 */


function round(number, precision) {
  if (precision === void 0) {
    precision = 0;
  }
  /** @type {?} */


  var factor = Math.pow(10, Math.trunc(precision));
  return Math.round(number * factor) / factor;
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * This method is like `sum` except that it accepts `iteratee` which is invoked for each element in `array` to generate the value to be summed. The iteratee is invoked with one argument: (value).
 *
 * Differences from lodash:
 * - does not skip `undefined` values
 *
 * Contribution to minified bundle size, when it is the only function imported:
 * - Lodash: 13,873 bytes
 * - Micro-dash: 52 bytes
 * @template T
 * @param {?} array
 * @param {?} iteratee
 * @return {?}
 */


function sumBy(array, iteratee) {
  return array.reduce(function (sum, element) {
    return sum + iteratee(element);
  }, 0);
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * Clamps `number` within the inclusive lower and upper bounds.
 *
 * Differences from lodash:
 * - `lower` is required
 * - does not coerce bounds that are `NaN` to be `0`
 *
 * Contribution to minified bundle size, when it is the only function imported:
 * - Lodash: 1,334 bytes
 * - Micro-dash: 51 bytes
 * @param {?} number
 * @param {?} lower
 * @param {?} upper
 * @return {?}
 */


function clamp(number, lower, upper) {
  return Math.min(upper, Math.max(lower, number));
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * Checks if `n` is between `start` and up to, but not including, `end`. If start is greater than end the params are swapped to support negative ranges.
 *
 * Differences from lodash:
 * - `start` and `end` are both required
 * - does not coerce falsey bounds to `0`
 *
 * Contribution to minified bundle size, when it is the only function imported:
 * - Lodash: 1,374 bytes
 * - Micro-dash: 59 bytes
 * @param {?} number
 * @param {?} start
 * @param {?} end
 * @return {?}
 */


function inRange(number, start, end) {
  return number >= Math.min(start, end) && number < Math.max(start, end);
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * Splits `string` into an array of its words.
 *
 * Differences from lodash:
 * - does not accept a `pattern` argument
 *
 * Contribution to minified bundle size, when it is the only function imported:
 * - Lodash: 2,229 bytes
 * - Micro-dash: 177 bytes
 * @param {?} string
 * @return {?}
 */


function words(string) {
  return string // between lower & upper
  .replace(/([a-z])([A-Z])/g, "$1 $2") // between number & letter
  .replace(/(\d)([A-Za-z])/g, "$1 $2").replace(/([A-Za-z])(\d)/g, "$1 $2") // before last upper in a sequence followed by lower
  .replace(/\b([A-Z]+)([A-Z])([a-z])/, "$1 $2$3").match(/[A-Za-z0-9]+/g) || [];
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * Converts the first character of `string` to upper case.
 *
 * Differences from lodash:
 * - requires `string` to be a string
 *
 * Contribution to minified bundle size, when it is the only function imported:
 * - Lodash: 1,887 bytes
 * - Micro-dash: 47 bytes
 * @param {?} string
 * @return {?}
 */


function upperFirst(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * Converts the first character of `string` to upper case and the remaining to lower case.
 *
 * Differences from lodash:
 * - requires `string` to be a string
 *
 * Contribution to minified bundle size, when it is the only function imported:
 * - Lodash: 1,924 bytes
 * - Micro-dash: 62 bytes
 * @param {?} string
 * @return {?}
 */


function capitalize(string) {
  return upperFirst(string.toLowerCase());
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * Converts `string` to camel case.
 *
 * Differences from lodash:
 * - requires `string` to be a string
 *
 * Contribution to minified bundle size, when it is the only function imported:
 * - Lodash: 5,242 bytes
 * - Micro-dash: 308 bytes
 * @param {?} string
 * @return {?}
 */


function camelCase(string) {
  return words(string).map(function (w, i) {
    return i ? capitalize(w) : w.toLowerCase();
  }).join("");
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * Converts `string`, as a whole, to lower case just like `String#toLowerCase`.
 *
 * Differences from lodash:
 * - requires `string` to be a string
 *
 * Contribution to minified bundle size, when it is the only function imported:
 * - Lodash: 989 bytes
 * - Micro-dash: 17 bytes
 * @param {?} string
 * @return {?}
 */


function toLower(string) {
  return string.toLowerCase();
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * Converts `string` to [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
 *
 * Contribution to minified bundle size, when it is the only function imported:
 * - Lodash: 4,261 bytes
 * - Micro-dash: 247 bytes
 * @param {?} string
 * @return {?}
 */


function kebabCase(string) {
  return words(string).map(toLower).join("-");
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * Pads `string` on the left and right sides if it's shorter than `length`. Padding characters are truncated if they can't be evenly divided by `length`.
 *
 * Contribution to minified bundle size, when it is the only function imported:
 * - Lodash: 3,373 bytes
 * - Micro-dash: 191 bytes
 * @param {?} s
 * @param {?} length
 * @param {?=} chars
 * @return {?}
 */


function pad(s, length, chars) {
  if (chars === void 0) {
    chars = " ";
  }
  /** @type {?} */


  var needed = (length - s.length) / 2;
  return _makePadding(Math.floor(needed), chars) + s + _makePadding(Math.ceil(needed), chars);
}
/**
 * @hidden
 * @param {?} s
 * @param {?} length
 * @param {?} chars
 * @return {?}
 */


function makePadding(s, length, chars) {
  return _makePadding(length - s.length, chars);
}
/**
 * @param {?} needed
 * @param {?} chars
 * @return {?}
 */


function _makePadding(needed, chars) {
  return needed > 0 && chars.length > 0 ? chars.repeat(Math.ceil(needed / chars.length)).substr(0, needed) : "";
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * Pads `string` on the left side if it's shorter than `length`. Padding characters are truncated if they exceed `length`.
 *
 * Contribution to minified bundle size, when it is the only function imported:
 * - Lodash: 3,297 bytes
 * - Micro-dash: 169 bytes
 * @param {?} s
 * @param {?} length
 * @param {?=} chars
 * @return {?}
 */


function padStart(s, length, chars) {
  if (chars === void 0) {
    chars = " ";
  }

  return makePadding(s, length, chars) + s;
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * Pads `string` on the right side if it's shorter than `length`. Padding characters are truncated if they exceed `length`.
 *
 * Contribution to minified bundle size, when it is the only function imported:
 * - Lodash: 3,297 bytes
 * - Micro-dash: 169 bytes
 * @param {?} s
 * @param {?} length
 * @param {?=} chars
 * @return {?}
 */


function padEnd(s, length, chars) {
  if (chars === void 0) {
    chars = " ";
  }

  return s + makePadding(s, length, chars);
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * Converts `string` to [snake case](https://en.wikipedia.org/wiki/Snake_case)
 *
 * Contribution to minified bundle size, when it is the only function imported:
 * - Lodash: 4,281 bytes
 * - Micro-dash: 247 bytes
 * @param {?} string
 * @return {?}
 */


function snakeCase(string) {
  return words(string).map(toLower).join("_");
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */


export { chunk, compact, flatten, last, pull, pullAt, remove, uniq, without, zip, every, filter, find, forEach, forEachRight, includes, keyBy, map, reduce, reduceRight, sortBy, curry, memoize, once, partial, castArray, clone, cloneDeep, isBoolean, isEmpty, isEqual, isFunction, isMatch, isNil, isNumber, isRegExp, isString, isUndefined, toString, minBy, random, round, sumBy, clamp, inRange, forOwn, forOwnRight, get, keys, mapValues, merge, omit, omitBy, pick, pickBy, set, update, values, camelCase, capitalize, kebabCase, pad, padStart, padEnd, snakeCase, toLower, upperFirst, words, constant, debounce, flow, flowRight, identity, matches, noop, times, uniqueId };